export enum PuDo {
  PU_I = 0,
  DO_I = 1,
  PU_R = 2,
  DO_R = 3,
  "-" = 4,
}

export function GetPuDoDisplayName(puDo: PuDo | undefined) {
  if (puDo !== undefined) return PuDo[puDo];
}
